// extracted by mini-css-extract-plugin
module.exports = {"DashContainer":"styles_DashContainer__3IGzm"};